export default "__VITE_ASSET__e04b1853__"